import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { SearchModal } from '../../../feature/search-bar/search-modal/search-modal';
import { MatDialog } from '@angular/material/dialog';
import { select } from '@ngxs/store';
import { LayoutState } from '@dis/shared';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'jtms-header-search',
  imports: [MatIcon],
  templateUrl: './header-search.html',
  styleUrl: './header-search.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSearch {
  #dialog = inject(MatDialog);

  isHandset = select(LayoutState.isHandset);

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.openSearchModal();
    }
  }

  openSearchModal(): void {
    this.#dialog.open(SearchModal, {
      position: { top: '80px' },
      width: '75vw',
      panelClass: 'search-modal-panel',
    });
  }
}
